import(/* webpackMode: "eager", webpackExports: ["Container","PageTitle","CardContainer","Card","Title","Description"] */ "/vercel/path0/frontend/src/app/projetos/styles.ts");
